var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import axios from "./http.js";
import { detectPreferredLocale } from "../utils/locale";
const _LeftTreeApi = class _LeftTreeApi {
  // In-memory cache object
  static _getActiveLocale() {
    try {
      const stored = localStorage.getItem("locale");
      if (stored)
        return stored;
    } catch (e) {
    }
    return detectPreferredLocale() || "ru";
  }
  static getLeftTreeData() {
    const abortController = new AbortController();
    return {
      async call() {
        const locale = _LeftTreeApi._getActiveLocale();
        const endpoint = `/v5/LeftTree/web`;
        const cacheKey = `${endpoint}|locale=${locale}`;
        if (_LeftTreeApi.cache.has(cacheKey)) {
          return Promise.resolve(_LeftTreeApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal
        }).then((response) => {
          _LeftTreeApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
};
__publicField(_LeftTreeApi, "cache", /* @__PURE__ */ new Map());
let LeftTreeApi = _LeftTreeApi;
var stdin_default = LeftTreeApi;
export {
  stdin_default as default
};
